import useSWR from "swr";
import useFetcher from "@/utils/use-fetcher";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";

export interface ListLineSheetSetProductsPathParameter {
  lineSheetSetId: number;
}

export interface ListLineSheetSetProductsRequest {
  brandId?: number;
  lineSheetId?: number;
  // 시즌별 상품 조회 (SEASON 타겟용)
  season?: string;
}

export interface LineSheetSetProduct {
  id: number;
  sku: string;
  brandId: number;
  brandName: string;
  productName: string;
  gender: string | null;
  category: string | null;
  subCategory: string | null;
  season: string | null;
  note: { [key: string]: string } | null;
  images: string[];
  priceAdjustedBy?: {
    by: "MARKUP" | "DISCOUNT";
    value: number;
    applyIva: boolean | null;
  } | null;
}

export type ListLineSheetSetProductsResponse = LineSheetSetProduct[];

export const listLineSheetSetProductsTemplateUrl =
  "/line-sheet-sets/:lineSheetSetId/products";

export default function useListLineSheetSetProducts(
  parameter?: ListLineSheetSetProductsPathParameter,
  request?: ListLineSheetSetProductsRequest
) {
  const fetcher = useFetcher<
    ListLineSheetSetProductsRequest,
    ListLineSheetSetProductsResponse
  >();

  const key =
    parameter !== undefined
      ? {
          url: calcUrl(listLineSheetSetProductsTemplateUrl, parameter),
          params: request,
        }
      : null;

  return useSWR(key, fetcher, {
    revalidateOnMount: true,
    revalidateIfStale: true,
    revalidateOnFocus: false,
    dedupingInterval: 0,
  });
}
